import hooks from './custom-hooks';
import validators from './validators';

export default {
  hooks,
  validators,
};
